module.exports = __webpack_public_path__ + "img/chart_sort_top.1016e32d.svg";